import React from "react";
import { Typography, makeStyles } from "@material-ui/core";
import { CreditCard, Description } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  container: {
    position: "relative",
    width: (props) => (props.isVideo ? 300 : undefined),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "100%",
    minHeight: "300px", // Hauteur minimale pour assurer un bon centrage vertical
  },
  iconHolder: {
    width: 500,
    display: "flex",
    justifyContent: "space-between",
    position: "absolute",
    bottom: "-150px",
    left: "50%",
    transform: "translateX(-50%)",
  },
  iconHolderVideo: {
    display: "flex",
    justifyContent: "space-around",
  },
  icon: {
    fontSize: "7rem",
    color: theme.palette.primary.main,
  },
  iconVideo: {
    fontSize: "3rem",
    color: theme.palette.primary.main,
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    flex: 1,
  },
}));

export default function DefaultTechnicianMessage({
  isVideo = false,
  customWaitingMessage = "",
}) {
  const classes = useStyles({ isVideo });

  const variant = isVideo ? "body1" : "h3";
  const iconClass = isVideo ? classes.iconVideo : classes.icon;
  const iconHolderClass = isVideo
    ? classes.iconHolderVideo
    : classes.iconHolder;

  return (
    <div className={classes.container}>
      <div className={classes.textContainer}>
        <Typography
          variant={variant}
          style={{
            padding: isVideo ? "10px" : "50px",
            textAlign: "center",
          }}
        >
          {customWaitingMessage ||
            "Installez-vous sur le fauteuil, un préleveur va vous prendre en charge."}
        </Typography>
        {!customWaitingMessage && (
          <Typography
            variant={variant}
            style={{
              padding: isVideo ? "0 10px 5px" : "0 50px 25px",
              textAlign: "center",
            }}
          >
            Merci d'insérer votre carte vitale dans le lecteur et de préparer
            votre ordonnance et votre carte de mutuelle.
          </Typography>
        )}
      </div>
      <div className={iconHolderClass}>
        <CreditCard className={iconClass} />
        <Description className={iconClass} />
      </div>
    </div>
  );
}
